export enum CountryMilestoneDependencyEntityType {
  MILESTONE = 'MILESTONE',
  TASK = 'TASK',
}
